import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-14 px-4 sm:px-6 bg-white" data-id="element-84" data-mp="1o3x3nprb6w3l">
      <div className="text-center mb-8" data-id="element-85" data-mp="1o3dm4a5km9q3">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-3 uppercase leading-tight" data-id="element-86" data-mp="2236a3xppqbud">
          YOUR INVESTMENT IS 100% PROTECTED
        </h2>
      </div>

      <div className="bg-brand-paper border-2 border-brand-sage p-8 sm:p-10 rounded-2xl text-center shadow-lg max-w-3xl mx-auto relative overflow-hidden" data-id="element-87" data-mp="1x2igr5e0hiwz">
        <div className="absolute top-0 left-0 w-full h-2 bg-brand-sage" data-id="element-88" data-mp="14gz36h5xs7eu" />

        <div className="w-20 h-20 mx-auto bg-brand-sage/10 rounded-full flex items-center justify-center mb-6 border border-brand-sage/30" data-id="element-89" data-mp="1j4tz06f8qrw5">
          <ShieldCheck className="w-10 h-10 text-brand-sage" data-id="element-90" data-mp="1ecixx08rl020" />
        </div>
        <h3 className="text-xl sm:text-2xl font-heading font-black text-brand-navy mb-4 uppercase leading-tight" data-id="element-91" data-mp="qmyeyhcm22sq">
          🛡️ 7-Day Money-Back Guarantee
        </h3>
        <p className="text-base font-bold text-brand-ink mb-5 uppercase tracking-wide" data-id="element-92" data-mp="ozrsamz5l05m">
          Your purchase is completely risk-free.
        </p>
        <p className="text-sm sm:text-base text-brand-ink/80 leading-relaxed mb-5" data-id="element-93" data-mp="tx1k29a0lnwm">
          Take seven full days to explore the entire system, review every
          module, implement the templates, organize your workflow, and start
          using the resources with your patients.
        </p>
        <p className="text-sm sm:text-base text-brand-ink/80 leading-relaxed font-medium" data-id="element-94" data-mp="628el61r2tcv">
          If for any reason you're not completely satisfied, simply contact us
          within the first 7 days and we'll refund 100% of your purchase.
          <br data-id="element-95" data-mp="k06re70fahq9" />
          <span className="text-brand-sage font-bold block mt-2" data-id="element-96" data-mp="k0ovfptbu08q">
            No risk. No questions asked.
          </span>
        </p>
      </div>
    </section>;
}